<template>
  <div id="home" class="dx-theme-accent-as-background-color">
        <img src="../assets/logo.svg" alt="PagoUno Logo">
       <FormLogin />
  </div>
</template>

<script>
import { onMounted } from '@vue/runtime-core';
import FormLogin from '../components/FormLogin.vue';
import themeChanger from '../themeChanger.js';

export default {
  name: 'Home',
  components: {
    FormLogin
  },
  setup() {

    const tc = new themeChanger();
    
    onMounted( ()=> {
      console.log('mounted');
      tc._removeDarkTheme();
    });
  }
}
</script>

<style scoped>
  #home {
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  #home img {
    width: 300px;
  }

</style>
